export const pathes = {
  BASE_PATH: "/citizen-club",
  DEFAULT: "/",
  ROLE_SCOPES: "/role-scopes",
  CREDIT_SUBMIT: "/credit-submit",
  SUCCESS_SUBMIT: "/success-submit",
};
